/* eslint-disable react/no-array-index-key */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import RenderTextField from '../../../../../utils/renderFields/RenderTextField';
import RenderSelectField from '../../../../../utils/renderFields/RenderSelectField';
import currency from '../../../../../utils/bindings/currency';
import { shouldMakeCustomDeclaration } from '../../../../../utils/validator';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
`;

const DeleteButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;
`;

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3)
  },
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(3)
  },
  paper: {
    padding: theme.spacing(2),
    margin: 'auto',
    maxWidth: 500
  }
}));

/**
 * Formulaire permettant de mettre à jours les produit présent
 * dans la commande
 *
 * @param {Object} fields       The Fields object
 * @param {Number} commandIndex Index de la commande actuelle
 */
const RenderProducts = ({ fields, currentCommand }) => {
  const classes = useStyles();
  return (
    <div>
      <ButtonContainer>
        <Button color="primary" variant="contained" type="submit">
          Mettre à jour
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            const {
              recipientAddress: { countryCode, postalCode }
            } = currentCommand;
            const addCustomsDeclarationField = shouldMakeCustomDeclaration(
              countryCode,
              postalCode
            );
            const newField = addCustomsDeclarationField
              ? {
                  customsDeclaration: {
                    originCountryCode: '',
                    objectType: '',
                    declaredValue: '',
                    currency: '',
                    quantity: null
                  }
                }
              : {};
            fields.insert(0, newField);
          }}
        >
          Ajouter un produit
        </Button>
      </ButtonContainer>
      {fields.map((item, index) => (
        <div key={index} className={classes.root}>
          <Paper className={classes.paper}>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <Field
                  name={`${item}.externalReference`}
                  label="Référence du produit ( sku )"
                  component={RenderTextField}
                  displayErrorBeforeSubmit
                  fullWidth
                  type="text"
                />
              </Grid>
              <Grid item md={6}>
                <Field
                  name={`${item}.ean13`}
                  label="Code-barres (EAN 13)"
                  component={RenderTextField}
                  displayErrorBeforeSubmit
                  fullWidth
                  type="text"
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <Field
                  name={`${item}.quantity`}
                  label="Quantité"
                  component={RenderTextField}
                  displayErrorBeforeSubmit
                  fullWidth
                  type="number"
                />
              </Grid>
              <Grid item md={6}>
                <Field
                  name={`${item}.description`}
                  label="Description"
                  component={RenderTextField}
                  displayErrorBeforeSubmit
                  fullWidth
                  type="text"
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <Field
                  name={`${item}.size`}
                  label="Taille"
                  component={RenderTextField}
                  displayErrorBeforeSubmit
                  fullWidth
                  type="text"
                />
              </Grid>
              <Grid item md={6}>
                <Field
                  name={`${item}.color`}
                  label="Couleur"
                  component={RenderTextField}
                  displayErrorBeforeSubmit
                  fullWidth
                  type="text"
                />
              </Grid>
            </Grid>

            {/* Custotm declaration */}
            {fields.get(index).customsDeclaration ? (
              <>
                <Grid container spacing={2}>
                  <Grid item md={6}>
                    <Field
                      name={`${item}.customsDeclaration.declaredValue`}
                      label="Valeur déclarée"
                      component={RenderTextField}
                      displayErrorBeforeSubmit
                      fullWidth
                      type="text"
                    />
                  </Grid>
                  <Grid item md={6}>
                    <Field
                      name={`${item}.customsDeclaration.currency`}
                      label="Devise"
                      component={RenderSelectField}
                      displayErrorBeforeSubmit
                      style={{ width: '100%' }}
                      datas={currency}
                      type="text"
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item md={6}>
                    <Field
                      name={`${item}.customsDeclaration.objectType`}
                      label="Description douane"
                      component={RenderTextField}
                      displayErrorBeforeSubmit
                      fullWidth
                      type="text"
                    />
                  </Grid>
                </Grid>
              </>
            ) : null}
            <DeleteButtonContainer>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => fields.remove(index)}
              >
                Supprimer
              </Button>
            </DeleteButtonContainer>
          </Paper>
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = state => ({
  currentCommand: state.commands.currentCommand
});

RenderProducts.propTypes = {
  fields: PropTypes.object.isRequired,
  currentCommand: PropTypes.object.isRequired
};

export default connect(mapStateToProps)(RenderProducts);
